// extracted by mini-css-extract-plugin
export default {"root":"KQ5QPSHPaIMXHgcG3z9w"};